// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.standard-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 10px;
}

.standard-row>* {
    padding: 20px;
    /* Add padding to all direct children of OTP-Page-Container */
}
.mobile-row{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px;
}


.charge-item {
    flex: 4 1;
    min-width: 80%;
    width: 80%;
    /* This makes the first child take up 80% of the available space */
    padding: 10px;
    /* Adjust padding as needed */
}

.charge-item-mobile {
    flex: 4 1;
    min-width: 80%;
    width: 80%;
    font-size: "11px";
}

.charge-tile {
    display: flex;
}

table.charge-table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    display: table;
    border: 1px solid #ccc;
    margin: 10px;
  }
  table.charge-table th,
  table.charge-table td:first-child {
    width: 35%;
  }

  
  .charge-progress-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100px;
    max-height: 100px;
    margin: 10px auto; /* Center horizontally */
  }

  
.charge-progress-indicator-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 80px;
    max-height: 80px;
    padding: 5px;
  }
  
  .charge-tile-mobile {
    height: 100%;
    width: 100%;
    max-width: 70vw;
    max-height: -moz-fit-content;
    max-height: fit-content;
    min-height: 10vh;
    background-color: #334191;
    color: #fff;
    display: flex;
    flex-direction:row;
    align-items:center;
    justify-content: space-around;
    font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/css/components/ChargeTile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,6DAA6D;AACjE;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,SAAO;IACP,cAAc;IACd,UAAU;IACV,kEAAkE;IAClE,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,cAAc;IACd,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,UAAU;EACZ;;;EAGA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB,EAAE,wBAAwB;EAC7C;;;AAGF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB","sourcesContent":[".standard-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 10px;\r\n}\r\n\r\n.standard-row>* {\r\n    padding: 20px;\r\n    /* Add padding to all direct children of OTP-Page-Container */\r\n}\r\n.mobile-row{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 5px;\r\n}\r\n\r\n\r\n.charge-item {\r\n    flex: 4;\r\n    min-width: 80%;\r\n    width: 80%;\r\n    /* This makes the first child take up 80% of the available space */\r\n    padding: 10px;\r\n    /* Adjust padding as needed */\r\n}\r\n\r\n.charge-item-mobile {\r\n    flex: 4;\r\n    min-width: 80%;\r\n    width: 80%;\r\n    font-size: \"11px\";\r\n}\r\n\r\n.charge-tile {\r\n    display: flex;\r\n}\r\n\r\ntable.charge-table {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n    width: 100%;\r\n    display: table;\r\n    border: 1px solid #ccc;\r\n    margin: 10px;\r\n  }\r\n  table.charge-table th,\r\n  table.charge-table td:first-child {\r\n    width: 35%;\r\n  }\r\n\r\n  \r\n  .charge-progress-indicator {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    max-width: 100px;\r\n    max-height: 100px;\r\n    margin: 10px auto; /* Center horizontally */\r\n  }\r\n\r\n  \r\n.charge-progress-indicator-mobile {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    max-width: 80px;\r\n    max-height: 80px;\r\n    padding: 5px;\r\n  }\r\n  \r\n  .charge-tile-mobile {\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 70vw;\r\n    max-height: fit-content;\r\n    min-height: 10vh;\r\n    background-color: #334191;\r\n    color: #fff;\r\n    display: flex;\r\n    flex-direction:row;\r\n    align-items:center;\r\n    justify-content: space-around;\r\n    font-size: 11px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
